"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WILDCARD_ENTITY = void 0;
var normalizr_1 = require("normalizr");
exports.WILDCARD_ENTITY = 'CasetivityEntity';
var createUnionSchema = function (entitySchemas) {
    var allSchemas = {};
    entitySchemas.forEach(function (e) {
        allSchemas[e.key] = e;
    });
    return new normalizr_1.schema.Union(allSchemas, 'entityType');
};
exports.default = createUnionSchema;
//# sourceMappingURL=createUnionSchema.js.map